import React from 'react';
import Html from 'components/html';
import type { StyledElement } from 'contracts';
import toArray from 'utils/to-array';

import styles from './equation-box.module.scss';

interface EquationBoxElement extends StyledElement {
  header: string;
  amount: string;
  footer?: string;
  variant?: 'default' | 'footerHighlight' | 'highlight' | 'intro';
}

const EquationBox: React.FunctionComponent<EquationBoxElement> = (props) => {
  const { header, amount, footer, className, style, variant = 'default' } = props;

  return (
    <Html.div className={[styles.equationBox, styles[variant], ...toArray(className)]} style={style}>
      <Html.div className={styles.meta}>
        <Html.div className={[styles.header, 'm-0']}>{header}</Html.div>
        <Html.div className={[styles.amount, 'm-0']}>{amount}</Html.div>
        {footer && <Html.div className={[styles.footer, 'm-0']}>{footer}</Html.div>}
      </Html.div>
    </Html.div>
  );
};

export type { EquationBoxElement };
export default EquationBox;
